import { FC } from 'react';
import BlockIcon from '@mui/icons-material/Block';
import { Box, BoxProps } from '@mui/material';
import clsx from 'clsx';

import useStyles from './CalendarCard.styles';

export type CalendarCardType = 'blockTime' | 'vacation' | 'sick' | 'child_sick';

interface Props extends BoxProps {
  allDay?: boolean;
  type: CalendarCardType;
}

export const CalendarCard: FC<Props> = ({
  allDay,
  className,
  type,
  ...props
}) => {
  const {
    root,
    allDayStyle,
    blockTimeStyle,
    vacationStyle,
    sickStyle,
    childSickStyle,
    icon,
  } = useStyles();

  const typeStyle = {
    blockTime: blockTimeStyle,
    child_sick: childSickStyle,
    sick: sickStyle,
    vacation: vacationStyle,
  }[type];

  return (
    <Box
      className={clsx(root, typeStyle, allDay && allDayStyle, className)}
      {...props}
    >
      {!allDay && type === 'blockTime' && <BlockIcon className={icon} />}
    </Box>
  );
};
